import React from "react";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import Features from "./Features";
import "./FeaturesSection.scss";

function FeaturesSection(props) {
  return (
    <Section
      color={props.color}
      size={props.size}
      backgroundImage={props.backgroundImage}
      backgroundImageOpacity={props.backgroundImageOpacity}
    >
      <div className="container">
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={3}
          spaced={true}
          className="has-text-centered"
        ></SectionHeader>
        <div className="FeaturesSection__box box">
          <Features
            columns={2}
            imageRatio="4by3"
            items={[
              {
                title: "Verified News",
                body:
                  "Get local, unbiased, and relevant news about COVID-19 from our team of crowd-sourcers who span communities across the U.S.",
                image: "./undraw_newspaper_k72w.svg"
              },
              {
                title: "Closest Testing Sites",
                body:
                  "Get real-time updates of the closest testing sites to you, letting you make smart, informed decions.",
                image: "./undraw-directions_x53j.svg"
              },
              {
                title: "Contextual Updates",
                body:
                  "We will only update you with alerts relevant to your situation, cutting out the alerts that are not pertinent to your situation.",
                image:
                  "./undraw_update_uxn2.svg"
              },
              {
                title: "Real-time Alerts & Info",
                body: "Get real-time summative information on Covid.",
                image:
                  "./undraw-personal_settings_kihd.svg"
              }
            ]}
          ></Features>
        </div>
      </div>
    </Section>
  );
}

export default FeaturesSection;
